import Link from '@platform-ui-common/components/Link/index.js';
import { Variant } from '@platform-ui-common/components/Typography/index.js';

export const ZelleWebsite = ({ variant }: { variant?: Variant }): JSX.Element => (
  <Link
    external
    to="https://www.zellepay.com/faq/how-do-i-change-account-i-use-send-and-receive-money"
    target="_blank"
    rel="noopener noreferrer"
    variant={variant}
  >
    Zelle website
  </Link>
);

export const ZelleNetwork = ({ variant }: { variant?: Variant }): JSX.Element => (
  <Link
    external
    to="https://www.zellepay.com/get-started"
    target="_blank"
    rel="noopener noreferrer"
    variant={variant}
  >
    Zelle network
  </Link>
);
